export default "__VITE_ASSET__adff3ad6__"